/**
 * Created by: cparaschiv
 * Date: 15.10.2013, 17:53
 */

var baseMapping = TS.domain.properties.DomainProperty.prototype.mapping;

/**
 * @ignore
 * @class TS.domain.properties.Breadcrumb
 */
TS.domain.properties.Breadcrumb = new Class(
/** @lends TS.domain.properties.Breadcrumb# */
{

	Extends: TS.domain.properties.DomainProperty,

	mapping: $.extend({}, baseMapping, {
		//ignore: baseMapping.ignore.concat([]),
		copy: baseMapping.copy.concat(['CommandCategory']),
		suppress: baseMapping.suppress.concat(['CommandCategory'])
	}),

    activeIndex: 0,

    commandCategory: null,

    initialize: function (domain, config) {
        var me = this;
        me.parent(domain, config);
    },

    hookDomain: function (viewModel) {
    	var me = this,
			domain = me.Domain(),
            cat, commands;

        if (me.CommandCategory) {
        	var category = domain.CommandCategories[me.CommandCategory];
        	if (!category) {
                TS.Log.warn('Cannot find command category ' + me.CommandCategory + ' for breadcrumb ' + me.Name);
            }
        	me.Commands = category.Commands;
        	me._setCommandsIsActive(me.Commands());
        	me.Commands.subscribe(me._onCommandsChanged, me);
        }
    },

    _setCommandsIsActive: function(commands){
        var me = this;

        $.each(commands, function(idx, cmd){
            var active = false;

            if (idx == me.ActiveIndex()){
                active = true;
            }

            if (ko.isObservable(cmd.isActive)){
                cmd.isActive(active);
            }
            else {
                cmd.isActive = ko.observable(active);
            }
        });
    },

    _onCommandsChanged: function(newValue){
        var me = this;
        me._setCommandsIsActive(newValue);
    },
});

TS.ObjectFactory.map('breadcrumb', TS.domain.properties.Breadcrumb);